
import axios from '../axios'
// 查询标注人员分类数量
export const sign_type_number = (data) => {
    return axios({
        url: '/admin/service/sign_type_number',
        method: 'post',
        data
    })
}
// 预警各类型次数统计环形
export const sys_warn_round = (data) => {
    return axios({
        url: '/admin/service/sys_warn_round',
        method: 'post',
        data
    })
}
// /get_house_type
export const house_type = (data) => {
    return axios({
        url: '/admin/service/get_house_type',
        method: 'post',
        data
    })
}
// sys_warn_day_statistics
export const warnDay = (data) => {
    return axios({
        url: '/admin/service/sys_warn_day_statistics',
        method: 'post',
        data
    })
}
// sys_visitor_week_statistics 获取访客记录
export const visitorDay = (data) => {
    return axios({
        url: '/admin/service/sys_visitor_week_statistics',
        method: 'post',
        data
    })
}
// sys_active_statistics
export const active_statistics = (data) => {
    return axios({
        url: '/admin/service/sys_active_statistics',
        method: 'post',
        data
    })
}
// sys_car_day_statistics
export const car_day_statistics = (data) => {
    return axios({
        url: '/admin/service/sys_car_day_statistics',
        method: 'post',
        data
    })
}
// sys_car_week_statistics
export const car_week_statistics = (data) => {
    return axios({
        url: '/admin/service/sys_car_week_statistics',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/first.js